<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Work Session Shift Codes"
      text="Create work session shift code"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="!loading">
        <v-container
          class="overflow"
          data-simplebar
        >
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="code"
                v-validate="'required'"
                :error-messages="errors.collect('code')"
                data-vv-name="code"
                data-vv-as="code" 
                label="Code"
                outlined
              />
            </v-col>
            <v-col 
              cols="6"
              class="py-0 pr-2"
            >
              <v-text-field
                v-model="startTime"
                v-validate="'required|time_before_or_equal:' + endTime"
                :error-messages="errors.collect('startTime')"    
                data-vv-name="startTime"
                data-vv-as="start time"
                outlined
                label="Start Time"
                type="time"
              />
            </v-col>
            <v-col 
              cols="6"
              class="py-0 pl-2"
            >
              <v-text-field
                v-model="endTime"
                v-validate="'required|time_after_or_equal:' + startTime"
                :error-messages="errors.collect('endTime')"    
                data-vv-name="endTime"
                data-vv-as="end time"
                outlined
                label="End Time"
                type="time"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-textarea
                v-model="description"
                :rows="2"
                outlined
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      workSessionType: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,
        code: this.workSessionType.code,
        description: null,
        startTime: '00:00:00',
        endTime: '00:00:00',
      }
    },
    watch: {
      workSessionType: function (value) {
        if (!value) return
        this.code = this.workSessionType.code
      },
    },
    mounted () {
      function toMinutes (time) {
        if (!time) return null
        const [h, m] = time.split(':')
        return (parseInt(h) * 60) + parseInt(m)
      }

      this.$validator.extend('time_before_or_equal', {
        getMessage (field, args) {
          return `The ${field} must be earlier than end time.`
        },
        validate (value, args) {
          const [otherValue] = args
          return toMinutes(value) <= toMinutes(otherValue)
        },
      })

      this.$validator.extend('time_after_or_equal', {
        getMessage (field, args) {
          return `The ${field} must be later than start time.`
        },
        validate (value, args) {
          const [otherValue] = args
          return toMinutes(value) >= toMinutes(otherValue)
        },
      })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.shiftCodes().create(this.workSessionType.id, this.prepareFormData())
              .then((res) => {
                this.$emit('created')            
                this.$snack({ message: 'Added new shift code' })

                this.progressing = false
                this.resetForm()
                this.dialog = false        
              })
              .catch((err) => {
                if (err.response.data.message) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                } else {
                  this.$snack({ 
                    color: 'error',
                    message: 'Failed to create new shift code', 
                  })
                }
            
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          code: this.code,
          description: this.description,
          start_time: this.startTime,
          end_time: this.endTime,
        }
      }, 
      resetForm () {
        this.$validator.reset()
        this.code = null
        this.description = null
        this.startTime = '00:00:00'
        this.endTime = '00:00:00'
      },
    },
  }
</script>
